/**
 * LocationIndicator.js - Indicador de ubicación actual en el header
 *
 * Muestra la ubicación del usuario y permite cambiarla
 */

import React from 'react';
import { colors } from '../styles';
import { getLocationDisplayText } from '../services/locationService';

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0.625rem 0.875rem',
    backgroundColor: colors.accentLight,
    borderRadius: '8px',
    marginBottom: '1rem',
  },
  locationInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.375rem',
    minWidth: 0,
    flex: 1,
  },
  icon: {
    fontSize: '0.875rem',
    flexShrink: 0,
  },
  text: {
    fontSize: '0.8125rem',
    color: colors.textPrimary,
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  changeButton: {
    padding: '0.5rem 0.75rem',
    backgroundColor: colors.accent,
    border: 'none',
    borderRadius: '6px',
    fontSize: '0.75rem',
    fontWeight: 600,
    color: '#fff',
    cursor: 'pointer',
    flexShrink: 0,
    marginLeft: '0.5rem',
  },
  helpText: {
    fontSize: '0.6875rem',
    color: colors.textMuted,
    marginTop: '0.25rem',
  },
  noLocation: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0.625rem 0.875rem',
    backgroundColor: colors.warningBg,
    border: `1px solid ${colors.warning}`,
    borderRadius: '8px',
    marginBottom: '1rem',
    cursor: 'pointer',
  },
  noLocationText: {
    fontSize: '0.8125rem',
    color: colors.warning,
    fontWeight: 500,
  },
};

export default function LocationIndicator({ location, onChangeClick }) {
  // Si no hay ubicación, mostrar aviso
  if (!location) {
    return (
      <div style={styles.noLocation} onClick={onChangeClick}>
        <span style={{ ...styles.icon, marginRight: '0.375rem' }}>📍</span>
        <span style={styles.noLocationText}>
          Selecciona tu ubicación para ver servicios cercanos
        </span>
      </div>
    );
  }

  const displayText = getLocationDisplayText(location);

  return (
    <div style={styles.container}>
      <div style={styles.locationInfo}>
        <span style={styles.icon}>📍</span>
        <div>
          <span style={styles.text}>
            Buscando cerca de: {displayText}
          </span>
          <p style={styles.helpText}>¿No estás ahí? Toca "Cambiar"</p>
        </div>
      </div>
      <button style={styles.changeButton} onClick={onChangeClick}>
        Cambiar
      </button>
    </div>
  );
}
